var plugin_default = {
  "alignLeft": "CpBa4",
  "textWrapNowrap": "vQmwt",
  "alignRight": "NLIhb",
  "alignCenter": "yxsMm",
  "sizeFullWidth": "-MWaz",
  "renderedInTable": "vaLu9",
  "sizeOriginal": "X3e-e",
  "sizeContent": "EOojp",
  "sizeSmall": "uPiLT",
  "sizeSmallCenter": "iytJH",
  "flex": "xvHsB",
  "atomic": "rTLis",
  "embed": "db4S4",
  "horizontalScrollbar": "BwDUN",
  "pluginContainerMobile": "UxZL1"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
